<script>
  import { dataset } from "../stores.js";
  import { getFlagUrl } from "../utils/countryFlags.js";

  export let active;

  import Template from "../components/TemplateSimple.svelte";


  let selectedLetter = "All";
  let searchQuery = "";

  function getCountryLetter(countryName) {
    return (countryName || "").trim().charAt(0).toUpperCase();
  }

  function sortCountries(a, b) {
    return a.country.localeCompare(b.country, undefined, { sensitivity: "base" });
  }

  function setLetter(letter) {
    selectedLetter = letter;
  }

  function filterCountry(event) {
    const value = event.currentTarget.value.trim();
    searchQuery = value;

    const match = countryEntries.find((country) => country.country === value);
    if (match) window.location.hash = "/profile/" + match.iso;
  }

  $: countryEntries = $dataset
    ? Object.values($dataset.countries)
        .filter((country) => country && country.country && country.available === true)
        .sort(sortCountries)
    : [];

  $: alphabet = countryEntries ? ["All",...new Set(countryEntries.map((country) => country.country[0]).sort())] : ["All"];

  $: normalizedQuery = searchQuery.trim().toLowerCase();

  $: filteredCountries = countryEntries.filter((country) => {
    const matchesLetter =
      selectedLetter === "All" || getCountryLetter(country.country) === selectedLetter;
    const matchesSearch =
      !normalizedQuery || country.country.toLowerCase().includes(normalizedQuery);

    return matchesLetter && matchesSearch;
  });

  $: groupedCountries = filteredCountries.reduce((groups, country) => {
    const letter = getCountryLetter(country.country);
    const existingGroup = groups.find((group) => group.letter === letter);

    if (existingGroup) {
      existingGroup.items.push(country);
    } else {
      groups.push({ letter, items: [country] });
    }

    return groups;
  }, []);
</script>

<Template active={active}>
  <header class="analysis-hero">
    <div class="container-fluid wrap">
      <div class="row">
        <div class="col-xs-12">
          <nav aria-label="Breadcrumb">
            <ol class="breadcrumb">
              <li><a href="#/">SCORE Home</a></li>
              <li><span aria-current="page">Country/Analysis</span></li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </header>

  <section class="analysis">
    <div class="container-fluid wrap">
      <div class="row analysis-toolbar">
        <div class="col-xs-12 col-md-9">
          <div class="analysis-filter-buttons">
            {#each alphabet as letter}
              <button
                type="button"
                class="btn {selectedLetter === letter ? 'btn-active' : 'btn-primary'} analysis-filter-button"
                aria-pressed={selectedLetter === letter}
                on:click={() => setLetter(letter)}
              >
                {letter}
              </button>
            {/each}
          </div>
        </div>

        <div class="col-xs-12 col-md-3">
          <div class="search">
            <input
              type="text"
              placeholder="Click below or search by country"
              list="countries-list"
              bind:value={searchQuery}
              on:change={filterCountry}
            />
            <span></span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.7 20.7">
              <circle cx="9.5" cy="9.5" r="8.5" />
              <line x1="15.9" y1="15.9" x2="19.7" y2="19.7" />
            </svg>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          {#if groupedCountries.length}
            {#each groupedCountries as group}
              <div class="analysis-country-group">
                <h3 class="analysis-list-title">{group.letter}</h3>
                <ul class="analysis-list">
                  {#each group.items as country}
                    <li>
                      <a href={"#/profile/" + country.iso}>
                        <img
                          class="analysis-flag"
                          src={getFlagUrl(country.iso)}
                          alt={"Flag of " + country.country}
                          loading="lazy"
                          width="24"
                          height="18"
                        />
                        <span>{country.country}</span>
                      </a>
                    </li>
                  {/each}
                </ul>
              </div>
            {/each}
          {:else}
            <div class="analysis-empty">
              <p>No countries found for the current filter.</p>
            </div>
          {/if}
        </div>
      </div>
    </div>

    <datalist id="countries-list">
      {#each countryEntries as country}
        <option value={country.country}></option>
      {/each}
    </datalist>
  </section>
</Template>
